module.exports = __webpack_public_path__ + "static/media/noun-partner.9cef668d.svg";